$(document).ready(function () {
    // if (location.hash) { 
    //     var navHeight = $('.header--main__nav.fixed').height();
    //     $('html, body').animate({
    //         scrollTop: $(location.hash).offset().top - navHeight
    //     }, 900);
    // }

    var Site = {
        init: function () {
            Site.scrollMenu();
            Site.accordion();
            Site.scrollToAnchor();
            Site.animations();
        },

        scrollMenu: function() {
            $(window).scroll(function() {
                var stickOn = $('.header--main').height();
                var scroll = $(window).scrollTop();
            
                if (scroll >= stickOn) {
                    $(".header--main__nav.fixed").addClass("disabled");
                } else if (scroll <= stickOn) {
                    $(".header--main__nav.fixed").removeClass("disabled");
                }
            });
        },
        
        accordion: function () {
            $('#accordionHowtoinstall [id^=collapse], #accordionFaq [id^=collapse]').on('show.bs.collapse', function () {
                var accordionId = this.id;
                $('[data-target="#'+ accordionId +'"] .fas').toggleClass('fa-plus-circle fa-minus-circle');
            });
  
            $('#accordionHowtoinstall [id^=collapse], #accordionFaq [id^=collapse]').on('hide.bs.collapse', function () {
                var accordionId = this.id;
                $('[data-target="#'+ accordionId +'"] .fas').toggleClass('fa-minus-circle fa-plus-circle');
            })
        },

        scrollToAnchor: function() {
            var navHeight = $('.header--main__nav.fixed').height();
            $(".mobile-nav li.scroll a").on('click', function(event) {
                $('#menuMobile').modal('hide');
            });
            $("li.scroll a, .scroll").on('click', function(event) {
                $('#menuMobile').modal('hide');
                if(window.location.pathname == '/') {
                    event.preventDefault();
                    var hash = this.hash;
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, 900);
                }
            });
        },

        animations: function () {
            var options = {
                animateThreshold: 300,
                scrollPollInterval: 20
            }
            $('.aniview').AniView(options);
            var options = {
                animateThreshold: 200,
                scrollPollInterval: 60
            }
            $('.aniview--delay').AniView(options);
        }
    }

    Site.init();
});
